/**
 * Resolve which product-level gallery rows to show for a UniKitOut PDP
 * (mirrors amber-cms `src/lib/unikitoutResolvedGallery.ts`).
 */

export const UNIKITOUT_DEFAULT_GALLERY_TAG = "default";

export type UnikitoutGalleryRow = {
  isFeatured?: boolean | null;
  tags?: string[] | null;
  image?: unknown;
};

function normalizeTags(tags: unknown): string[] {
  if (!Array.isArray(tags)) return [];
  return tags.filter((t): t is string => typeof t === "string" && t.trim().length > 0);
}

/**
 * Rows with no tags are always shown (legacy). Rows with `default` always show.
 * Other tags require a match in `activeImageTags`.
 */
export function resolveUnikitoutGallery(
  images: UnikitoutGalleryRow[] | null | undefined,
  activeImageTags: string[],
): UnikitoutGalleryRow[] {
  const rows = images || [];
  const active = new Set(activeImageTags.filter(Boolean));

  return rows.filter((row) => {
    const tags = normalizeTags(row.tags);
    if (tags.length === 0) return true;
    if (tags.includes(UNIKITOUT_DEFAULT_GALLERY_TAG)) return true;
    for (const t of tags) {
      if (active.has(t)) return true;
    }
    return false;
  });
}

export function unikitoutVariantImageTag(optionGroupName: string, choiceLabel: string): string {
  const slug = (s: string) =>
    s
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  return `${slug(optionGroupName)}:${slug(choiceLabel)}`;
}
